import LayoutFull from './Full'
import LayoutMain from './Main'
import LayoutDashboard from './Dashboard'

export {
  LayoutMain,
  LayoutFull,
  LayoutDashboard
}
